import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import CompareProFeatureTableHeaderCell from './CompareProFeatureTableHeaderCell';
const StaticTable = styled.table.withConfig({
  displayName: "CompareProFeatureTableStaticHeader__StaticTable",
  componentId: "sc-1d81qiw-0"
})(["margin-bottom:0;"]);
const THead = styled.thead.withConfig({
  displayName: "CompareProFeatureTableStaticHeader__THead",
  componentId: "sc-1d81qiw-1"
})(["height:150px;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;vertical-align:bottom;line-height:100%;border:none !important;}"]);

const CompareProFeatureTableStaticHeader = ({
  levelsAndApiNames
}) => {
  return /*#__PURE__*/_jsx(StaticTable, {
    children: /*#__PURE__*/_jsx(THead, {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          style: {
            paddingBottom: 12,
            paddingLeft: 12
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.productCatalog.tableHeader.features"
          })
        }), levelsAndApiNames.map(item => {
          return /*#__PURE__*/_jsx(CompareProFeatureTableHeaderCell, {
            productLevel: item.level,
            columns: levelsAndApiNames.length,
            productLine: item.productLine,
            isStaticHeader: true
          }, item.level);
        })]
      })
    })
  });
};

export default CompareProFeatureTableStaticHeader;